import { type NotifyOnChangeProps, useQuery } from '@tanstack/react-query';

import { featureFlags } from 'services/featureFlags/featureFlags';

type Options = {
  enabled?: boolean;
  staleTime?: number;
  refetchOnWindowFocus?: boolean;
  refetchOnReconnect?: boolean;
  refetchInterval?: number | false;
  initialData?: Record<string, boolean>;
};

const defaultOptions: Options = {
  enabled: true,
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchInterval: false,
};

export const usePeertransferFlags = (
  flagOrFlags: string[] | string,
  options: Options = {},
) => {
  const flags = Array.isArray(flagOrFlags) ? flagOrFlags : [flagOrFlags];

  return useQuery({
    queryKey: ['flags', ...flags],
    queryFn: (): Promise<Record<string, boolean>> => {
      return featureFlags.fetch(flags);
    },
    ...defaultOptions,
    ...options,
    staleTime: options.staleTime ?? defaultOptions.staleTime,
    notifyOnChangeProps: ['data', 'error'] as NotifyOnChangeProps,
  });
};
